import { Routes } from '@angular/router';
import { PaneladminComponent } from './paneladmin.component';
import {guardsGuard } from './guards.guard';
import { LoginadmComponent } from '../../loginadm/loginadm.component';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { adminInterceptor } from '../admin-interceptor.interceptor';


export const adminRoutes: Routes = [
    {
        path: '',
        component: LoginadmComponent,
    },
    
    {
        path: 'admin',
        component: PaneladminComponent,
        providers: [
            provideHttpClient(withInterceptors([adminInterceptor]))
        ],
        canActivateChild: [guardsGuard],
        children: [
            {
                path: 'panel',
                component: PaneladminComponent,
               
            }
        ]
    }
]